import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { AddCustomerVehicleResponseModel } from '../business-entities/add-customer-vehicle-response.interface';
import { CreateContactRequestModel } from '../business-entities/create-contact-request-model';
import { FindCarDataService } from '../data-services/find-car-data.service';

@Injectable({ providedIn: 'root' })
export class FindCarService {
    constructor(
        private fcDataService: FindCarDataService
    ) { }

    getCustomerAndVehicleDetails(licensePlate: string): Promise<GenericResponse<any>> {
        return this.fcDataService.getCustomerAndVehicleDetails(licensePlate);
    }

    getCustomerAndVehicleDetailsUsingMobile(mobileNo: string,mobileCode:string): Promise<GenericResponse<any>> {
        return this.fcDataService.getCustomerAndVehicleDetailsUsingMobile(mobileNo,mobileCode);
    }

    getBrandDetais(): Promise<GenericResponse<any>> {
        return this.fcDataService.getBrandDetais();
    }

    getCountryCodeAndMobileCodeDetails(): Promise<GenericResponse<any>> {
        return this.fcDataService.getCountryCodeAndMobileCodeDetails();
    }

    getFuelTypeDetails(): Promise<GenericResponse<any>> {
        return this.fcDataService.getFuelTypeDetails();
    }

    getVehicleTypes(): Promise<GenericResponse<any>> {
        return this.fcDataService.getVehicleTypes();
    }

    checkCustomerDetails(model: any): Promise<GenericResponse<any>> {
        return this.fcDataService.checkCustomerDetails(model);
    }

    AddCustomerVehicleDetails(model: AddCustomerVehicleResponseModel): Promise<GenericResponse<any>> {
        return this.fcDataService.AddCustomerVehicleDetails(model);
    }
    AddCustomerMobile(model: any): Promise<GenericResponse<any>> {
        return this.fcDataService.AddCustomerVehicleDetails(model);
    } 
    async GetVehicleTransmissionDropdownList():Promise<any>{
        return  this.fcDataService.GetVehicleTransmissionDropdownList();
    }
    async GetModelnoDropdownList(make:string):Promise<any>{
        return this.fcDataService.GetModelnoDropdownList(make);
    }
    CreateContact(model: CreateContactRequestModel): Promise<any> {
        return this.fcDataService.CreateContact(model);
    }
    AssignDriverToVehicle(vehicleId: string, driverId: string): Promise<any> {
        return this.fcDataService.AssignDriverToVehicle(vehicleId, driverId);
    } 
}
